/**
 * @file h5曝光埋点
 * @author sunhemeng
 */
import { sendUbcShowLog } from '../../static/utils/ubcMethods.js';
import log from '../../static/utils/ubcLog';
let observerData = null;
export function getObserver(key, isUbc, logKey, isNewLog, isNotRepeat = false, options) {
  const {
    threshold = 0.75,
    referencedDOM = '',
    cb
  } = options || {};
  let observer = new IntersectionObserver(changes => {
    changes.forEach(change => {
      cb && cb instanceof Function && cb(change);
      let container = change.target;
      if (change.intersectionRatio > threshold) {
        if (isNewLog) {
          const ext = container.getAttribute('data-exts');
          log.send({
            serverId: container.getAttribute('data-serverid'),
            area: container.getAttribute('data-area'),
            action: 'show',
            ext: ext,
            ...(ext && JSON.parse(ext))
          });
          // 停止监听
          isNotRepeat && observer.unobserve(change.target);
          return;
        }
        sendUbcShowLog({
          page: container.getAttribute('data-page'),
          value: container.getAttribute('data-value'),
          ext: container.getAttribute('data-ext') ? JSON.parse(container.getAttribute('data-ext')) : ''
        });
      }
    });
  }, {
    // 如果不设置threshold  那么默认element intersectionRatio = 0就是没在页面展示的时候 就已经触发了 回掉函数
    threshold: [threshold],
    ...(referencedDOM && {
      root: document.querySelector(referencedDOM)
    })
  });
  observerData = observer;
  return observer;
}
/**
 * inSightObserverH5
 * 判断元素是否出现在view之内，上报曝光日志
 * 依赖dom元素上的 data-key 区分是否已发送过日志。
 *
 * @param {Boolean} isNotRepeat 是否重复打点
 * @param {Object} options 其他参数，不再堆叠下去了，否则可读性太差
 * @param {number} threshold 触发曝光的阈值，h5默认0.75
 */
export function inSightObserverH5(key, isUbc = false, logKey = '', isNewLog = false, isNotRepeat, options) {
  let observer = getObserver(key, isUbc, logKey, isNewLog, isNotRepeat, options);
  query(key).forEach(item => {
    observer.observe(item);
  });
}
export function inSightObserverDisconnectH5() {
  try {
    observerData && observerData.disconnect();
    observerData = null;
  } catch (error) {}
}
export function query(selector) {
  return Array.from(document.querySelectorAll(selector));
}